export default {"src":"/_next/static/media/circles.fe2ba01a.svg","height":378,"width":631,"blurWidth":0,"blurHeight":0};